import {createSelector, MemoizedSelector} from '@ngrx/store';
import {
  selectActiveJob,
  selectActiveRevision,
  selectRequestedRevisionId
} from '@ispm/workflow/store/workflow-config.selectors';
import {IRevision} from "@ispm/core/interfaces/workflow.interface";
import {pathwaySelectionJobPurpose} from "@ispm-client/modules/pathways";
import {IWorkflowJobItem} from "@ispm/workflow/interfaces/job-item.interface";

const getIsPathwaysSelectionActive = (activeJob: IWorkflowJobItem, activeRevision: IRevision, selectedRevisionId: string): boolean => {
  return selectedRevisionId && activeRevision && activeJob.purpose ?
    (selectedRevisionId === activeRevision.id) && activeJob.purpose.toLowerCase() === pathwaySelectionJobPurpose.toLowerCase() : false;
};

export const selectIsPathwaysSelectionActive: MemoizedSelector<object, boolean> = createSelector(
  selectActiveJob,
  selectActiveRevision,
  selectRequestedRevisionId,
  getIsPathwaysSelectionActive);


